var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCloseCross = function SvgCloseCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.70714 0.292894C1.31661 -0.0976307 0.683448 -0.0976307 0.292924 0.292894C-0.0976005 0.683418 -0.0976012 1.31658 0.292923 1.70711L14.4352 15.8494L0.293075 29.9915C-0.0974495 30.382 -0.0974495 31.0152 0.293075 31.4057C0.683599 31.7962 1.31676 31.7962 1.70729 31.4057L15.8494 17.2636L29.9914 31.4056C30.3819 31.7961 31.0151 31.7961 31.4056 31.4056C31.7961 31.0151 31.7961 30.3819 31.4056 29.9914L17.2636 15.8494L31.4058 1.7072C31.7963 1.31668 31.7963 0.683513 31.4058 0.292989C31.0152 -0.0975356 30.3821 -0.0975352 29.9916 0.292989L15.8494 14.4352L1.70714 0.292894Z",
    fill: "#6371DE"
  })));
};
export default SvgCloseCross;